<p>deeplink-player-modal works!</p>
<div>
    {{ data }}
</div>
